// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Labels = require("../../../reason/clients/components/Labels.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let BuyerNeedStatus_buyerNeedV5_graphql = require("../../../__generated__/BuyerNeedStatus_buyerNeedV5_graphql.bs.js");

let convertFragment = BuyerNeedStatus_buyerNeedV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BuyerNeedStatus_buyerNeedV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(BuyerNeedStatus_buyerNeedV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, BuyerNeedStatus_buyerNeedV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(BuyerNeedStatus_buyerNeedV5_graphql.node, convertFragment, fRef);
}

let BuyerNeedFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function BuyerNeed__Status$WithoutErrorBoundary(props) {
  let buyerNeed = RescriptRelay_Fragment.useFragment(BuyerNeedStatus_buyerNeedV5_graphql.node, convertFragment, props.buyerNeed);
  let s = buyerNeed.status;
  switch (s.__typename) {
    case "ActiveBuyerNeed" :
      return null;
    case "ExpiredBuyerNeed" :
      return JsxRuntime.jsx(Labels.ExpiredStatusLabel.make, {});
    case "InContractBuyerNeed" :
      return JsxRuntime.jsx(Labels.InContractLabel.make, {});
    case "PurchasedBuyerNeed" :
      return JsxRuntime.jsx(Labels.PurchasedLabel.make, {});
    case "WithdrawnBuyerNeed" :
      return JsxRuntime.jsx(Labels.WithdrawnLabel.make, {});
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected buyer need status ` + s._0);
  }
}

let WithoutErrorBoundary = {
  make: BuyerNeed__Status$WithoutErrorBoundary
};

function BuyerNeed__Status(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "buyer need status",
    children: JsxRuntime.jsx(BuyerNeed__Status$WithoutErrorBoundary, {
      buyerNeed: props.buyerNeed
    })
  });
}

let make = BuyerNeed__Status;

exports.BuyerNeedFragment = BuyerNeedFragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Labels Not a pure module */
